export const SearchBarBuilderComponent = {
  name: '_SearchBar_',
  inputs: [],
} as const;

export default SearchBarBuilderComponent;
